
import Vue from 'vue';
import Component from 'vue-class-component';
import MenuButton from '../MenuButton.vue';
import Pricelists from '../price-list/Pricelists.vue';
import ShopModal from '../shop/ShopModal.vue';
import PromoCodeModal from './PromoCodeModal.vue';
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/store/modules/User';
import store from '@/store';
import { polishPlurals } from "polish-plurals";
import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const { $vToastify: notifier } = new Vue() as any;
const userModule = getModule(UserModule, store);

@Component({
    components: {
        MenuButton,
        Pricelists,
        ShopModal,
        PromoCodeModal, // Added PromoCodeModal to components
    }
})
export default class Settings extends Vue {
    public menuOpen = false;

    get usedStorageBytes() {
        return userModule.usedStorageBytes;
    }

    get usedStorageString() {
        return this.usageAsString(this.usedStorageBytes);
    }

    get maxStorageBytes() {
        return userModule.user?.storageLimit || 0;
    }

    get maxStorageString() {
        return this.usageAsString(this.maxStorageBytes);
    }

    get capacityPercentage() {
        return this.usedStorageBytes * 100 / this.maxStorageBytes;
    }

    get isRawsUltimateActive() {
        // For now, hardcoded to match the ShopModal logic
        // In a real app, this would come from the user's subscription data
        return true; // Assuming active since the original text showed "1 sztuk" and "30 dni"
    }

    get ownedRawsOne() {
        // For now, hardcoded to match the ShopModal logic
        return 5;
    }
    public pricelistOpen = false;
    public shopModalOpen = false;
    public promoModalOpen = false; // Added promoModalOpen property
    public polishPlurals = polishPlurals;

    public playSlideSound() {
        const audio = createInterfaceSound('/sound/slide.wav');
        playInterfaceSound(audio).catch(error => {
            console.log('Audio playback failed:', error);
        });
    }

    openShop() {
        this.shopModalOpen = true;
    }

    openPromoModal() {
        this.promoModalOpen = true;
    }

    onCennikiClick() {
        // When Cenniki is clicked from dashboard, automatically open the cloud download modal
        this.$nextTick(() => {
            if (this.$refs.pricelistsComponent) {
                const pricelistsComponent = this.$refs.pricelistsComponent as Pricelists;
                // Wait for the dialog to open, then trigger the cloud download button
                setTimeout(() => pricelistsComponent.openList(), 100);
            }
        });
    }

    onPromoApplied(result: string) {
        notifier.success({
            title: 'Promocja zastosowana!',
            body: result,
        });
        // Handle the free sessions bonus
    }

    onPurchaseSuccess(purchaseInfo: { rawsOne: number; rawsUltimate: number; totalPrice: number }) {

        let message = 'Zakup zakończony sukcesem!<br>';
        if (purchaseInfo.rawsOne > 0) {
            message += `Raws ONE: ${purchaseInfo.rawsOne} szt.<br>`;
        }
        if (purchaseInfo.rawsUltimate > 0) {
            message += `Raws ULTIMATE: ${purchaseInfo.rawsUltimate} szt.<br>`;
        }
        message += `Łączna cena: ${purchaseInfo.totalPrice} zł`;

        notifier.success({
            title: 'Dziękujemy za zakup!',
            body: message,
        });
    }

    private usageAsString(bytes: number): string {
        const units = ['B', 'kB', 'MB', 'GB', 'TB'];
        let value = bytes;
        let unitIndex = 0;

        while (value >= 1024 && unitIndex < units.length - 1) {
            value /= 1024;
            unitIndex++;
        }

        return value % 1 !== 0
            ? `${value.toFixed(1)} ${units[unitIndex]}`
            : `${Math.floor(value)} ${units[unitIndex]}`;
    }
}
